<template>
  <div>
    <b-card v-if="USE_ASSET" id="popup" no-body>
      <b-tabs  pills card end>
        <b-tab :title="$t('message.position')" active><b-card-text>
          <b-container class="pr-4 pl-4 m-0">
            <b-row>
              <b-col cols="12">
                <h6>
                  {{extraData && extraData.properties ? DateTime.fromMillis(extraData.properties.ts * 1000).setLocale(lang).toFormat('dd LLL yyyy') : null}}
                  {{extraData && extraData.properties ? DateTime.fromMillis(extraData.properties.ts * 1000).setLocale(lang).toFormat('HH:mm:ss') : null}}
                </h6>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h6> {{$t('message.numberPlate', 1)}}: {{vehicle ? vehicle.plateNumber : null}} </h6>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h6>
                  {{$t('message.brand')}}: {{ vehicle && vehicle.type && vehicle.type.brand || $tc('message.emptyValue', 1)}}
                </h6>

                <h6>
                  {{$t('message.model', 1)}}: {{vehicle && vehicle.type && vehicle.type.model || $tc('message.emptyValue', 1)}}
                </h6>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h6> {{$t('message.driver')}}: {{driver && driver.name ? (`${driver.surname ? driver.surname : ''} ${driver.name ? driver.name : ''} - ${driver.taxCode ? driver.taxCode : ''}`) : $tc('info.driverNotAssociated', 1)}} </h6>
              </b-col>
            </b-row>

            <b-row v-if="extraData && extraData.properties">
              <b-col cols="12">
                <h6>{{$t('message.engine')}}: {{extraData && extraData.properties && extraData.properties.events && extraData.properties.events.engineStatus ? $t('message.on').toLowerCase() : $t('message.off').toLowerCase()}}</h6>
              </b-col>

              <b-col cols="12">
                <h6>{{$t('message.speed')}} {{extraData && extraData.properties.events.gpsSpeed}} km/h</h6>
              </b-col>
            </b-row>

            <b-row class="mb-2">
              <b-col cols="12">
                {{$t('message.obu')}}: {{tracker && tracker.serialNumber || $tc('message.emptyValue', 1)}}
              </b-col>

              <b-col cols="12" v-if="extraData && extraData.geometry && extraData.geometry.coordinates && first(extraData.geometry.coordinates) && extraData.geometry.coordinates[1]">
                {{$t('message.latitude')}}: {{extraData.geometry.coordinates[1]}}
              </b-col>

              <b-col cols="12" v-if="extraData && extraData.geometry && extraData.geometry.coordinates && first(extraData.geometry.coordinates) && extraData.geometry.coordinates[1]">
                {{$t('message.longitude')}}: {{first(extraData.geometry.coordinates)}}
              </b-col>
            </b-row>

            <b-row>
              <link-list refs="linkList" :value="links" :hideLabel="hideLabel" @clicked-link="clickedLink"/>
            </b-row>
          </b-container>

        </b-card-text></b-tab>
        <b-tab :title="$t('message.tool')">
            <b-container v-if="extraData && extraData.blescans" class="max-height-200-px">
              <b-table show-empty striped caption-top hover :fields="[{ key: 'tagCode', label: `${$tc('message.tag')}`},
              { key: 'typeString', label: `${$tc('message.type')}`}]" :items="extraData.blescans">
                <template #empty="">
               {{`${$tc('message.courtesyMessageTable', 1)}`}}
              </template></b-table>
            </b-container>
            <b-container class="p-3" v-else>
              {{`${$tc('message.courtesyMessageTable', 1)}`}}
            </b-container>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-container v-else class="m-0">
      <b-row>
        <b-col cols="12">
          <h6>
            {{extraData && extraData.properties ? DateTime.fromMillis(extraData.properties.ts * 1000).setLocale(lang).toFormat('dd LLL yyyy') : null}}
            {{extraData && extraData.properties ? DateTime.fromMillis(extraData.properties.ts * 1000).setLocale(lang).toFormat('HH:mm:ss') : null}}
          </h6>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h6> {{$t('message.numberPlate', 1)}}: {{vehicle ? vehicle.plateNumber : null}} </h6>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h6>
            {{$t('message.brand')}}: {{ vehicle && vehicle.type && vehicle.type.brand || $tc('message.emptyValue', 1)}}
          </h6>

          <h6>
            {{$t('message.model', 1)}}: {{vehicle && vehicle.type && vehicle.type.model || $tc('message.emptyValue', 1)}}
          </h6>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h6> {{$t('message.driver')}}: {{driver && driver.name ? (`${driver.surname ? driver.surname : ''} ${driver.name ? driver.name : ''} - ${driver.taxCode ? driver.taxCode : ''}`) : $tc('info.driverNotAssociated', 1)}} </h6>
        </b-col>
      </b-row>

      <b-row v-if="extraData && extraData.properties">
        <b-col cols="12">
          <h6>{{$t('message.engine')}}: {{extraData && extraData.properties && extraData.properties.events && extraData.properties.events.engineStatus ? $t('message.on').toLowerCase() : $t('message.off').toLowerCase()}}</h6>
        </b-col>

        <b-col cols="12">
          <h6>{{$t('message.speed')}} {{extraData && extraData.properties.events.gpsSpeed}} km/h</h6>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <b-col cols="12">
          {{$t('message.obu')}}: {{tracker && tracker.serialNumber || $tc('message.emptyValue', 1)}}
        </b-col>

        <b-col cols="12" v-if="extraData && extraData.geometry && extraData.geometry.coordinates && first(extraData.geometry.coordinates) && extraData.geometry.coordinates[1]">
          {{$t('message.latitude')}}: {{extraData.geometry.coordinates[1]}}
        </b-col>

        <b-col cols="12" v-if="extraData && extraData.geometry && extraData.geometry.coordinates && first(extraData.geometry.coordinates) && extraData.geometry.coordinates[1]">
          {{$t('message.longitude')}}: {{first(extraData.geometry.coordinates)}}
        </b-col>
      </b-row>

      <b-row>
        <link-list refs="linkList" :value="links" :hideLabel="hideLabel" @clicked-link="clickedLink"/>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { DateTime, Settings } from 'luxon'
import Vue from 'vue'
const { first, isNil } = require('lodash')

export default {
  name: 'Popup',
  props: ['position', 'lang', '$t', 'hideLabel'],
  watch: {
    position (val) {
      const position = val
      const links = [
        {
          index: 0,
          to: 'EditVehicle',
          from: this.$route,
          title: `${this.$t('message.registry', 1)} ${this.$t('message.vehicle', 1).toLowerCase()}`,
          href: { name: 'EditVehicle', params: { id: (position && position.vehicle && position.vehicle.id) || null } },
          path: `/organization/registry_vehicles/${position && position.vehicle && position.vehicle.id}`
        }
      ]
      if (position.driver) {
        links.push({
          index: 1,
          to: 'EditStaff',
          from: this.$route,
          title: `${this.$t('message.registry', 1)} ${this.$t('message.driver', 1).toLowerCase()}`,
          href: { name: 'EditStaff', params: { id: (position && !isNil(position.driver) && !isNil(position.driver.id)) || null } },
          path: `/organization/registry_staff/${position && position.vehicle && position.driver.id}`
        })
      }
      this.links = links
      this.vehicle = val.vehicle || {}
      this.driver = val.driver || {}
      this.tracker = val.tracker || {}
      this.extraData = val.extraData || {}
    },
    lang (newVal) {
      Settings.defaultLocale = newVal
    }
  },
  data () {
    const position = this.position
    const USE_ASSET = Vue.getUseAssets()
    return {
      first,
      links: [],
      DateTime,
      USE_ASSET,
      vehicle: (position && position.vehicle) || null,
      driver: (position && position.driver) || null,
      tracker: (position && position.tracker) || null,
      extraData: (position && position.extraData) || null
    }
  },
  methods: {
    clickedLink (link) {
      this.$emit('redirect', link)
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 0;
}

</style>
